import { odrRepository } from '@repositories/odr';

import { Odr as OdrType } from '@app-types/odr';
import { Universe } from '@app-types/universe';

export function toOdrSlug(name: string): string {
    return name
        .toLowerCase()
        .normalize('NFD')
        .replaceAll(/[\u0300-\u036f]/g, '')
        .replaceAll(/\s+/g, '-')
        .replaceAll(/[^a-z0-9-]/g, '');
}

export class OdrService {
    async getAllOdrs(): Promise<OdrType[]> {
        return await odrRepository.findAll();
    }

    async getOdrById(id: string): Promise<OdrType | undefined> {
        return await odrRepository.findById(id);
    }

    async getOdrsByUniverse(universeIds: string[]): Promise<OdrType[]> {
        try {
            return await odrRepository.findByUniverse(universeIds);
        } catch {
            return [];
        }
    }

    async getUniverses(): Promise<Universe[]> {
        const odrs = await this.getAllOdrs();
        const seen = new Set<string>();

        return odrs.reduce<Universe[]>((acc, odr) => {
            if (!seen.has(odr.universeId)) {
                seen.add(odr.universeId);
                acc.push({
                    id: odr.universeId,
                    slug: toOdrSlug(odr.universeId),
                    name: odr.universeId,
                    order: acc.length,
                });
            }
            return acc;
        }, []);
    }
}

export const odrService = new OdrService();
